import { h, Fragment } from 'preact';
import CaretRight from '../utils/icon/caret-right.svg';

const MobileMenuItem = ({
  link,
  setSubmenuContent,
  setSubmobileOpened,
  setActiveSubMenu,
  setActiveSubMenuLink,
}) => (
  <li
    key={`${link.title}-${link.url}`}
    className="flex items-center justify-between font-x-large-bold text-black mb-8"
    onClick={() => {
      if (link?.submenus?.length > 0) {
        setSubmenuContent(link.submenus);
        setSubmobileOpened(true);
        setActiveSubMenu(link.title);
        setActiveSubMenuLink({ title: link.title, url: link.url });
      }
    }}
  >
    {link?.submenus?.length > 0 && (
      <>
        <span>{link.title}</span>
        <CaretRight />
      </>
    )}
    {link?.submenus?.length === 0 && (
      <a href={link.url} className={ `font-x-large-bold link-unstyled ${ link.title === 'Holiday Boutique' ? 'text-red' : 'text-black' }` }>
        <span>{link.title}</span>
      </a>
    )}
  </li>
);

export default MobileMenuItem;
